
export class ThumbnailConstants {
  thumbnails = {
    sizes: {
      small: [256, 256],
      large: [1024, 1024]
    }
  };
}
